let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iAaum"), load("bUC6C")]).then(() => parcelRequire('cz7bE'));